import PropTypes from "prop-types"
import { last } from "lodash"
import { Link } from "react-router-dom"
import Logo from "components/logo"
import ServerNotifications from "modules/server-notifications"
import HelpMenu from "modules/help-menu"
import ContextualMenu from "components/contextual-menu"

import "./style.scss"
import LegacySearch from "components/legacy-search"

export default function Nav({ account, watchlistName, modelId, menuItems }) {
  const path = last(window.location.pathname.split("/"))

  return <div className="watchlist-root-nav">
    <div className="left">
      <Link className="logo" to={`/${account}/home`}>
        <Logo />
      </Link>
      <ContextualMenu items={menuItems} />
      <div className="watchlist-name">{watchlistName}</div>
    </div>
    <div className="center">
      <LegacySearch location={path} modelId={modelId} />
    </div>
    <div className="right">
      <ServerNotifications />
      <HelpMenu modelId={modelId} />
    </div>
  </div>
}

Nav.propTypes = {
  account: PropTypes.string.isRequired,
  watchlistName: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  menuItems: PropTypes.array,
}
